import React from 'react'
import { func } from 'prop-types'
import { useAamState } from '../../../state/AamStore'
import PersonViewer from '../../../../../shared/components/PersonViewer/PersonViewer'
import { PersonViewerProvider } from '../../../../../shared/components/PersonViewer/state/PersonViewerStore'
import { PersonType } from '../../../../../shared/propTypes/personDataProps'

const clearUrl = () => {
  const params = new URLSearchParams(window.location.search)
  params.delete('experience')
  window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`))
}

export default function AncestorDetails({ person, setOpenAncestorDetails }) {
  const state = useAamState()

  return (
    <PersonViewerProvider>
      <PersonViewer
        personData={person}
        clearPerson={() => {
          setOpenAncestorDetails(false)
          clearUrl()
        }}
        tree={state.tree}
      />
    </PersonViewerProvider>
  )
}

AncestorDetails.propTypes = {
  person: PersonType,
  setOpenAncestorDetails: func,
}
